<style lang="scss">
* {
    margin: 0;
}

.login-content-div {
    margin: 0 !important;
    background: #f0f1f5;
    background-image:
        radial-gradient(circle at 20% 50%, rgba(99, 102, 241, 0.03) 0%, transparent 50%),
        radial-gradient(circle at 80% 80%, rgba(236, 72, 153, 0.03) 0%, transparent 50%);
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;

    @media screen and (max-width: 600px) {
        padding: 1rem;
    }
}

.content-div-out {
    position: relative;
    z-index: 1;
    display: flex;
    overflow: hidden;
    box-shadow:
        0 1px 3px rgba(0, 0, 0, 0.04),
        0 4px 12px rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    background: #fff;
    transition: all 0.15s ease;

    &:hover {
        box-shadow:
            0 1px 3px rgba(0, 0, 0, 0.06),
            0 4px 16px rgba(0, 0, 0, 0.06);
    }

    @media screen and (max-width: 600px) {
        width: 90vw !important;
        height: auto !important;
        margin: 0 !important;
        flex-direction: column;
    }

    @media screen and (min-width: 601px) {
        width: 60rem !important;
        height: 33rem !important;
        margin: 0 auto !important;
    }
}

.content-div-left {
    background: #6366f1;
    position: relative;
    overflow: hidden;

    @media screen and (max-width: 600px) {
        height: 35vh;
        width: 100% !important;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }

    @media screen and (min-width: 601px) {
        height: 33rem;
        width: 50%;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
    }
}

.content-div-right {
    background: #fff;
    position: relative;

    @media screen and (max-width: 600px) {
        height: auto;
        width: 100% !important;
        padding: 2rem 0;
        border-bottom-right-radius: 8px;
        border-bottom-left-radius: 8px;
    }

    @media screen and (min-width: 601px) {
        height: 33rem;
        width: 50%;
        border-bottom-right-radius: 8px;
        border-top-right-radius: 8px;
    }
}

.content-left-text {
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding: 2rem;
    position: relative;
    z-index: 1;

    .welcome-text {
        font-size: 2rem;
        font-weight: 700;
        margin-bottom: 0.75rem;
        letter-spacing: 0.02em;
    }

    span:last-child {
        font-size: 1rem;
        opacity: 0.9;
        letter-spacing: 0.02em;
    }
}

.content-right-login {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding: 2rem;
}

.form-el-data {
    width: 100%;
    max-width: 25rem;
    margin: 0 auto;

    :deep(.el-form-item__label) {
        font-weight: 500;
        color: #374151;
        font-size: 0.875rem;
        margin-bottom: 0.5rem;
    }

    :deep(.el-input__wrapper) {
        background: #fff;
        box-shadow: none;
        border: 1px solid #e5e7eb;
        transition: all 0.15s ease;
        border-radius: 6px;
        padding: 0.25rem 0.75rem;
        height: 2.75rem;

        &:hover {
            border-color: #d1d5db;
        }

        &:focus-within {
            border-color: #6366f1;
            box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
        }

        &.is-focus {
            box-shadow: none;
        }
    }

    :deep(.el-input__inner) {
        height: 2.25rem;
        font-size: 0.9375rem;
        color: #111827;

        &::placeholder {
            color: #9ca3af;
        }
    }

    :deep(.el-input__prefix),
    :deep(.el-input__suffix) {
        color: #9ca3af;
    }
}

.form-el-btn {
    margin: 2rem auto;
    width: 100%;
    max-width: 25rem;

    .el-button {
        width: 100%;
        height: 2.75rem;
        font-size: 0.9375rem;
        font-weight: 500;
        transition: all 0.15s ease;
        background: #6366f1;
        border: none;
        border-radius: 6px;

        &:hover {
            background: #4f46e5;
            transform: none;
        }

        &:active {
            background: #4338ca;
            transform: none;
        }
    }
}

.input-emailCode,
.input-kaptchaCode {
    :deep(.el-input__wrapper) {
        background: #fff;
        border: 1px solid #e5e7eb;
        box-shadow: none;
        transition: all 0.15s ease;
        border-radius: 6px;
        padding: 0.25rem 0.75rem;
        height: 2.75rem;

        &:hover {
            border-color: #d1d5db;
        }

        &:focus-within {
            border-color: #6366f1;
            box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
        }
    }
}

.send_emailCode {
    height: 2.75rem;
    border-radius: 6px;
    font-weight: 500;
    background: #6366f1;
    border: none;
    transition: all 0.15s ease;

    &:hover {
        background: #4f46e5;
    }

    &:active {
        background: #4338ca;
    }
}

.kaptchaImg {
    height: 2.75rem;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.15s ease;
    border: 1px solid #e5e7eb;

    &:hover {
        opacity: 0.9;
        transform: none;
        border-color: #d1d5db;
    }
}

.bottom-div {
    position: absolute;
    bottom: 1rem;
    left: 0;
    right: 0;
    text-align: center;

    a {
        color: #6366f1;
        text-decoration: none;
        font-size: 0.875rem;
        transition: all 0.15s ease;
        cursor: pointer;
        padding: 0.375rem 0.75rem;
        border-radius: 4px;

        &:hover {
            color: #4f46e5;
            background: rgba(99, 102, 241, 0.05);
            text-decoration: none;
        }
    }
}

@media screen and (max-width: 700px) {
    .form-el-data {
        width: 100%;
        max-width: none;
    }

    .btn-list {
        margin-top: 1rem !important;
    }

    .input-emailCode {
        width: 6rem !important;
    }

    .send_emailCode {
        margin-left: 1rem;
    }

    .input-kaptchaCode {
        width: 4rem !important;
    }

    .kaptchaImg {
        margin-left: 1rem !important;
        width: 50%;
    }
}

@media screen and (min-width: 701px) {
    .send_emailCode {
        margin-left: 1rem;
    }

    .input-emailCode,
    .input-kaptchaCode {
        width: 10rem !important;
    }
}
</style>

<template>
    <div class="login-content-div">
        <div class="content-div-out shadow row">
            <div class="content-div-left col-md-6">
                <div class="content-left-text">
                    <span class="welcome-text">欢迎登录</span>
                    <span>晓风软件授权系统</span>
                </div>
            </div>
            <div class="content-div-right col-md-6">
                <div class="content-right-login">
                    <div class="form-div">
                        <el-form label-position="top" label-width="auto" ref="loginForm" class="form-el-data"
                            :model="login" :rules="rules">
                            <el-form-item label="账号" prop="email">
                                <el-input placeholder="默认为您的邮箱" v-model="login.email" />
                            </el-form-item>
                            <el-form-item label="验证码" prop="code" v-if="login_act == 1">
                                <el-input type="text" placeholder="邮箱验证码" v-model="login.code"
                                    class="input-emailCode" />
                                <el-button @click="getcodeClick()" class="send_emailCode" type="primary">{{
                                    login.getcode.text }}</el-button>
                            </el-form-item>
                            <el-form-item label="密码" prop="password" v-else>
                                <el-input type="password" placeholder="您的密码" v-model="login.password" />
                            </el-form-item>
                            <el-form-item label="验证码" prop="code" v-if="login_act == 2">
                                <el-input type="text" placeholder="验证码" v-model="login.code"
                                    class="input-kaptchaCode" />
                                <img class="kaptchaImg" ref="kaptchaImg" src="" @click="getKaptcha()">
                                <!-- <img v-show="login.email==''" style="width: 0;height: 0;" ref="kaptchaImg2" src="" /> -->
                                <!-- <el-button @click="getKaptcha()" type="primary" v-if="kaptchaImgSrc==''">
                                    获取验证码
                                </el-button> -->
                            </el-form-item>
                        </el-form>
                        <el-form-item class="form-el-btn btn-list">
                            <el-button type="primary" v-if="login_act == 1" @click="submitForm('loginForm')"
                                class="codeLogin-btn">
                                账号验证码登录
                            </el-button>
                            <el-button type="primary" v-else @click="submitForm('loginForm')">
                                账号密码登录
                            </el-button>
                            <!-- <el-button v-loading.fullscreen.lock="fullscreenLoading" type="primary"
                                @click="openFullScreen1">
                            </el-button> -->
                        </el-form-item>

                    </div>
                    <div class="bottom-div">
                        <a @click="bottom_btnClick('pass')" v-if="login_act == 1">邮箱+密码登录</a>
                        <a @click="bottom_btnClick('code')" v-if="login_act == 2">邮箱+验证码登录</a>
                    </div>
                </div>
            </div>

            <div></div>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref, onMounted, watch } from 'vue'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
import { ElMessage } from 'element-plus';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    setup() {
        var login = ref({
            email: "",
            password: "",
            code: "",
            getcode: {
                text: "发送"
            },
        });
        var kaptchaImgToken = ref('')
        var login_act = ref(1)
        const bottom_btnClick = (act) => {
            if (act === "pass") {
                login_act.value = 2
            }
            else {
                login_act.value = 1
            }
        }
        const checkNumber = (rule, value, callback) => {
            if (!value || !isNaN(Number(value))) {
                callback();
            } else {
                callback(new Error('请输入数字验证码'));
            }
        }
        const rules = ({
            email: [
                { required: true, message: '请输入邮箱', trigger: ['change'] },
                { type: 'email', message: '请输入正确的邮箱格式', trigger: ['change'] },
            ],
            code: [
                { required: true, message: '请输入验证码' },
                { min: 1, max: 6, message: '验证码长度错误', trigger: ['blur', 'change'] },
            ],
            password: [
                { required: true, message: '请输入密码', trigger: ['change'] },
                { min: 6, max: 20, message: '长度在6-20位', trigger: ['change'] },
            ],
        })

        const loginForm = ref(null);

        // let fullscreenLoading
        // const openLoading = () => {
        //     fullscreenLoading = ElLoading.service({
        //         lock: true,
        //         text: 'Loading',
        //         background: 'rgba(0, 0, 0, 0.7)',
        //     })
        // }
        const debounce = (func, delay) => {
            let timeoutId;
            return (...args) => {
                clearTimeout(timeoutId);
                timeoutId = setTimeout(() => {
                    func(...args);
                }, delay);
            };
        };
        const submitForm = debounce((value) => {
            loginForm.value.validate((valid) => {
                if (valid) {
                    openLoading()
                    const data = new FormData()
                    data.append("email", login.value.email)
                    if (login_act.value == 1) {
                        data.append("act", "login_code")
                        data.append("code", login.value.code)
                    }
                    else {
                        data.append("act", "login_pass")
                        data.append("password", login.value.password)
                        data.append("code", login.value.code)
                        data.append("kaptchaImgToken", kaptchaImgToken.value)
                    }
                    axios.post(baseURL + "/userApi/login", data, { timeout: 5000 })
                        .then(res => {
                            fullscreenLoading.close()
                            if (res.data.code == 200) {
                                localStorage.setItem("token", res.data.token)
                                ElMessage.success(res.data.msg)
                                location.href = "/console"
                            }
                            else {
                                ElMessage.error(res.data.msg)
                                if (login_act.value != 1) {
                                    getKaptcha()
                                }
                            }
                        })
                        .catch(err => {
                            fullscreenLoading.close()
                            console.log(err)
                            ElMessage.error('请求失败' + err.message)
                        })
                }
                else {
                    ElMessage.error('请按照格式填写完整')
                }
            })
        }, 1000);
        const getcodeClick = () => {
            loginForm.value.validateField('email', (valid) => {
                if (valid) {
                    if (typeof login.value.getcode.text !== "string") {
                        ElMessage.error("请" + login.value.getcode.text + "秒后再试")
                        return
                    }
                    openLoading()
                    const data = new FormData()
                    data.append("email", login.value.email)
                    data.append("password", login.value.password)
                    data.append("act", "getcode")
                    axios.post(baseURL + "/userApi/login", data, { timeout: 10000 })
                        .then(res => {
                            fullscreenLoading.close()
                            if (res.data.code == 200) {
                                login.value.getcode.text = 60;
                                let code_text_inter = setInterval(() => {
                                    var code_text = login.value.getcode.text;
                                    if (code_text !== 0) {
                                        login.value.getcode.text--;
                                    }
                                    else if (code_text === 0) {
                                        login.value.getcode.text = "发送";
                                        clearInterval(code_text_inter)
                                    }
                                }, 1000);
                                ElMessage.success(res.data.msg)
                            }
                            else {
                                ElMessage.error(res.data.msg)
                            }
                        })
                        .catch(err => {
                            fullscreenLoading.close()
                            console.log(err)
                            ElMessage.error('请求失败' + err.message)
                        })
                }
                else {
                    ElMessage.error('请按照格式填写完整邮箱')
                }
            })
        }
        const isLogin = () => {
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.get(baseURL + "/userApi/isLogin", { timeout: 5000, headers: headers })
                .then(res => {
                    if (res.data.code == 200) {
                        ElMessage.success("您已经登录")
                        setTimeout(() => {
                            location.href = "/console"
                        }, 1000);
                    }
                })
                .catch(err => {
                    console.log(err)
                    ElMessage.error('请求失败：' + err.message)
                })
        }
        const kaptchaImg = ref(null)
        const getKaptcha = () => {
            axios.get(baseURL + "/userApi/getKaptcha")
                .then((res) => {
                    kaptchaImg.value.src = res.data.data
                    kaptchaImgToken.value = res.data.kaptchaImgToken
                })
        }
        watch(login_act, (newVal) => {
            if (newVal != 1) {
                getKaptcha()
            }
        })
        onMounted(isLogin)
        // 返回需要暴露给模板的数据
        return {
            login,
            login_act,
            rules,
            loginForm,
            kaptchaImg,
            kaptchaImgToken,
            bottom_btnClick,
            submitForm,
            getcodeClick,
            checkNumber,
            getKaptcha
        };
    },

})
</script>
